import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../Services/authentication.service';
import { MenuService } from 'src/app/Services/menu.service';
import { catchError, map, of } from 'rxjs';

export const routeGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const menuService = inject(MenuService);
  const router = inject(Router);

  const isLoggedIn = auth.isLoggedIn();
  const isLoginPath = state.url.includes('/login');

  if (isLoggedIn) {
    if (isLoginPath) {
      router.navigateByUrl(auth.getDefaultRoute());
      return false;
    }

    return menuService.loadCurrentMenus().pipe(
      map(() => {
        if (!auth.canAccessUrl(state.url)) {
          router.navigateByUrl(auth.getDefaultRoute());
          return false;
        }

        return true;
      }),
      catchError(() => {
        router.navigateByUrl(auth.getDefaultRoute());
        return of(false);
      })
    );
  }

  if (!isLoginPath) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
